import React from "react";
import {
	Checkbox,
	Tooltip
} from "rhombus-react";

import { TARGET_METHODS } from "utils/constants";
import AdvertiserObjective from "./AdvertiserObjective";


export default function ModernSelection(props){
	let {
		onChange,
		currentValue,
		onObjective,
		selectedObjective,
	} = props;

	function handleChange(e){
		if(e.target.checked){
			onChange(e.target.value);
		} else {
			onChange(TARGET_METHODS.MODERN);
		}
	}
	let $audLabel = (
		<React.Fragment>
			Enable Audience Optimization
			<Tooltip description="Optimized to deliver the best version to a user based on audience data."
				direction="top"
				size="large"
			/>
		</React.Fragment>
	);

	return (
		<div className="radio-options">
			<AdvertiserObjective onObjective={onObjective} selectedObjective={selectedObjective} targetMethod={currentValue} />
			<Checkbox
				className="audience-checkbox"
				label    = {$audLabel}
				key      = "modern audience"
				type     = "checkbox"
				onChange = {handleChange}
				value    = {TARGET_METHODS.MODERN_AUDIENCE}
				checked  = {TARGET_METHODS.MODERN_AUDIENCE === currentValue}
			/>
		</div>
	);
}
